(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('PaymentService', PaymentService)

    /** @ngInject */
    function PaymentService(HttpService) {
        const PaymentService = {
            getByParameters: getByParameters
        }

        return PaymentService;

        function getByParameters(params) {
            return HttpService.get('/payment/slips/by-parameters', {
                params
            });
        }
    }
}());